import api from '@/api-client'
import i18n from '@/i18n'

const changeFavicon = (url) => {
    let link = window.document.querySelector('link[rel*="icon"]') || window.document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    window.document.getElementsByTagName('head')[0].appendChild(link);
}

export default {
    async fetchConfig({ commit, dispatch }) {
        const { data: config } = await api.get('config');
        localStorage.removeItem('base-url')

        if (config.base_url) {
            localStorage.setItem('base-url', config.base_url)
        }

        if (config.favicon_url) {
            changeFavicon(config.favicon_url)
        }

        commit('setConfig', config);
        dispatch('visitorSettings/initialize')
        commit('setConfigLoaded')
        return config
    },

    setAuthFail({ commit, dispatch }, authFailed = true) {
        commit('setAuthFail', authFailed)
        // FIXME: use generic i18n key
        dispatch('messages/push',
                 i18n.global.t('subscriptions.errors.undefined'))
    },

    set404({ commit }, is404 = true) {
        commit('set404', is404)
    },

    setOffline({ commit }, offline) {
        commit('setOffline', offline)
    }
};
